const CheckCircleFill = ({ width = 16, height = 16, color = 'currentColor', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00065 14.6668C11.6826 14.6668 14.6673 11.6821 14.6673 8.00016C14.6673 4.31826 11.6826 1.3335 8.00065 1.3335C4.31875 1.3335 1.33398 4.31826 1.33398 8.00016C1.33398 11.6821 4.31875 14.6668 8.00065 14.6668ZM11.334 6.94296C11.5944 6.68261 11.5944 6.2605 11.334 6.00015C11.0737 5.7398 10.6516 5.7398 10.3912 6.00015L6.9003 9.49109L5.36881 7.70436C5.1292 7.42481 4.70833 7.39244 4.42878 7.63205C4.14923 7.87167 4.11686 8.29253 4.35647 8.57209L6.35647 10.9054C6.47732 11.0464 6.6515 11.1306 6.83706 11.1377C7.02262 11.1449 7.20274 11.0743 7.33405 10.943L11.334 6.94296Z"
        fill={color}
      />
    </svg>
  )
}

export default CheckCircleFill
